import React, { useMemo } from 'react'
import { PermissionIcon } from '@/components/agent-dashboard/assets';
import { useTranslation } from 'react-i18next';
import { agentPermissionHooks } from '@/manager';
import { AdminIcon, OperatorIcon } from './assets';
import { Skeleton } from '../ui/skeleton';

/** 智能体权限管理-卡片概览 */
export const DataOverview: React.FC = () => {
  const { t } = useTranslation();
  const { agentV2StatsData, loading } = agentPermissionHooks.useAgentV2Stats();

  // 统计数据
  const stats = useMemo(() => [
    {
      title: t('agent_dashboard.permission.admin_count'),
      count: agentV2StatsData?.adminCount || 0,
      icon: <PermissionIcon />,
    },
    {
      title: t('agent_dashboard.permission.super_admin'),
      count: agentV2StatsData?.superAdminCount || 0,
      icon: <AdminIcon />,
    },
    {
      title: t('agent_dashboard.permission.operator'),
      count: agentV2StatsData?.operatorCount || 0,
      icon: <OperatorIcon />,
    },
  ], [agentV2StatsData]);

  return (
    <div className='flex gap-5 flex-col lg:flex-row'>
      {(
        stats.map((stat, index) => (
          <div
            key={index}
            className='w-[22rem] max-w-[22rem] bg-white rounded-lg  border border-[rgba(233,234,235,1)] p-6 py-6 flex space-x-4 shadow-[0px_1px_2px_rgba(10,13,18,0.05)]'
          >
            <div className={`size-10 border border-[rgba(213,215,218,1)] rounded-md flex items-center justify-center shadow-sm flex-shrink-0`}>
              {stat.icon}
            </div>
            <div className='flex-1 space-y-2'>
              <div className='text-sm text-[rgba(102,112,133,1)] font-semibold'>{stat.title}</div>
              {loading && <Skeleton className='h-9 w-20 rounded' />}
              {!loading && <div className='text-3xl font-semibold text-[rgba(16,24,40,1)]'>{stat.count}</div>}
            </div>
          </div>
        ))
      )}
    </div>
  )
}

const SkeletonCard = () => (
  <div className='w-[22rem] max-w-[22rem] bg-white rounded-lg border border-[rgba(233,234,235,1)] p-6 py-6 flex space-x-4 shadow-[0px_1px_2px_rgba(10,13,18,0.05)]'>
    <div className='size-10  rounded-md flex items-center justify-center flex-shrink-0'>
      <div className='size-10 bg-[rgba(233,234,235,1)] rounded animate-pulse'></div>
    </div>
    <div className='flex-1 space-y-2'>
      <div className='h-6 bg-[rgba(233,234,235,1)] rounded animate-pulse w-24'></div>
      <div className='h-8 bg-[rgba(233,234,235,1)] rounded animate-pulse w-16'></div>
    </div>
  </div>
);